import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import {
  ReviewBoardListItem,
  ReviewBoardStatusResponse,
} from '@models/review-board.model';

@Injectable({
  providedIn: 'root',
})
export class ReviewBoardService {
  private readonly baseUrl = `${environment.apiUrl}/MipsReviewBoard`;

  constructor(private http: HttpClient) {}

  getList(): Observable<ReviewBoardListItem[]> {
    return this.http.get<ReviewBoardListItem[]>(this.baseUrl);
  }

  getStatus(submissionId: number): Observable<ReviewBoardStatusResponse> {
    return this.http.get<ReviewBoardStatusResponse>(`${this.baseUrl}/${submissionId}`);
  }

  requestReview(submissionId: number): Observable<ReviewBoardStatusResponse> {
    return this.http.post<ReviewBoardStatusResponse>(`${this.baseUrl}/${submissionId}/request`, {});
  }

  cancelReview(submissionId: number): Observable<ReviewBoardStatusResponse> {
    return this.http.post<ReviewBoardStatusResponse>(`${this.baseUrl}/${submissionId}/cancel`, {});
  }
}
